// extracted by mini-css-extract-plugin
export default {"link":"BvNsN5","root":"RnAGKZ","label":"eNXohE"};